// src/boot/directives.js
import Vue from 'vue';
import onExist from "../directives/v-on-exist";
export default (function () {
  // Registers 'v-on-exist' globally using the imported module configuration
  Vue.directive('on-exist', onExist);
});